import getCombatantIndexById from "./getCombatantIndexById";
import setPendingCA from "./setPendingCA";
// import getAction from "./getAction";
import store from "../store/index";
//---------------------------
// shift pending slots right
//---------------------------
export default function shiftPendingCAsRight(parm, action_number) {
  // console.log("------------------------------");
  // console.log("IN shiftPendingCAsRight");
  //--------------
  // access store
  //--------------
  const this_store = store.state.combat;
  let combatants = this_store.arena.arena_combatants;
  let maxCA = this_store.config.max_ca;
  //----------------
  // get cur action
  //----------------
  // let cur_action = getAction(parm.slot_name);
  //------------------
  // get combatant idx
  //------------------
  let i = getCombatantIndexById(parm.id);
  // console.log("------------------------------");
  // console.log("new_action name = " + new_action.name);
  //-------------------
  // get slot to right
  //-------------------
  let from_slot = Number(action_number) + 1;
  // console.log("from_slot = Number(action_number) + 1 ... " + action_number + " + 1 = " + from_slot);
  //----------
  // set vars
  //----------
  let combatant_ca = combatants[i].ca;
  let slots_used = combatants[i].actual_action_count;
  // console.log("slots_used = combatants[i].actual_action_count = " + combatants[i].actual_action_count);
  //---------------------------------------------------------------------
  // if new action = NOT actual + old action = Actual -> reduce used cnt
  //---------------------------------------------------------------------
  // if (cur_action) {
  //   if (new_action.actual == false && cur_action.actual) {
  //     // console.log("REDUCING SLOTS USED");
  //     slots_used--;
  //   }
  // }
  //-----------
  // calc vars
  //-----------
  let remaining_pending = combatant_ca - slots_used;
  // console.log("remaining_pending = combatant_ca - slots_used ... " + combatant_ca + " - " + slots_used + " = " + remaining_pending);
  let to_slot = from_slot + remaining_pending - 1;
  // console.log("to_slot = from_slot + remaining_pending - 1 ... " + from_slot + " - " + remaining_pending + ' - 1 = ' + to_slot);
  if (to_slot > maxCA) {
    // console.log("XXX")
    to_slot = maxCA;
  } else if (to_slot < from_slot) {
    // console.log("YYY")
    to_slot = from_slot;
  }
  //------------------------------------------------------------------
  // loop from slot next to where action changed -> remaining pending
  //------------------------------------------------------------------
  for (let k = from_slot; k <= to_slot; k++) {
    let ca_type = "ca_type" + k;
    // let ca_name = "ca_name" + k;

    // console.log(
    //   "k = " +
    //     k +
    //     " type = " +
    //     combatants[i][ca_type] +
    //     " name = " +
    //     combatants[i][ca_name]
    // );
    //-------------------
    // skip over markers
    //-------------------
    if (combatants[i][ca_type] != "marker") {
      // console.log("setting pending at " + k);
      //------------------
      // set pending slot
      //------------------
      let pending_parm = {
        id: parm.id,
        ca_num: k,
      };
      setPendingCA(pending_parm);
    } else {
      // console.log("skip as marker = " + k);
    }
  }
}
